import { Input } from '@chakra-ui/react'
export default Input
